/* eslint-disable camelcase */
const fb_share_wisdom = '我的錢包死掉了！這是能夠拯救我錢包的一句語錄，想知道妳的錢包會怎麼死嗎？快來測驗看看吧！';

const results = [
  {
    title: '手滑之死',
    tag: 'identity',
    quote: '跟主流不同又如何，不要當一個隨波逐流的人',
    quote_from: 'Adele',
    wisdom: '購物時，妳就像被紡織針刺傷的睡美人，不小心手滑的後果，醒來後都會後悔萬分',
    caption: '要把手管好啊',
    bannerImage: 'bannerImg1',
    figureImage: 'figureImg1',
    fb_share_game: '我的錢包變成刺到紡織針的睡美人死掉了，手滑的後果不堪設想！想知道妳的錢包會怎麼死嗎？快來測驗看看吧！',
    fb_share_wisdom,
    fb_share_href_princess: 'https://shopaholic.relab.cc/princess/1/',
    fb_share_href_quote: 'https://shopaholic.relab.cc/slogan/1/',
    fb_share_href_game: 'https://shopaholic.relab.cc/'
  },
  {
    title: '幻滅之死',
    tag: 'preference',
    quote: '美麗，是不能吃的，別用美麗餵養自己',
    quote_from: 'Lupita Nyong\'o',
    wisdom: '購物時，妳就像迷失在愛裡的小美人魚，只追求美麗的表面，而不管是否合適',
    caption: '妳以為美好的，不一定適合妳',
    bannerImage: 'bannerImg2',
    figureImage: 'figureImg2',
    fb_share_game: '我的錢包變成傷心欲絕的美人魚死掉了，原本以為美好的卻完全不適合！想知道妳的錢包會怎麼死嗎？快來測驗看看吧！',
    fb_share_wisdom,
    fb_share_href_princess: 'https://shopaholic.relab.cc/princess/2/',
    fb_share_href_quote: 'https://shopaholic.relab.cc/slogan/2/',
    fb_share_href_game: 'https://shopaholic.relab.cc/'
  },
  {
    title: '毒蘋果之死',
    tag: 'reciprocity',
    quote: '沒用的東西，再便宜也不要買',
    quote_from: '購物狂的異想世界',
    wisdom: '購物時，妳就像吃了毒蘋果的白雪公主，原以為是免費的東西，卻付出了很大的代價',
    caption: '原來，免費的東西才是最貴',
    bannerImage: 'bannerImg3',
    figureImage: 'figureImg3',
    fb_share_game: '我的錢包變成吃下毒蘋果的白雪公主死掉了，原來免費的東西才是最貴的！想知道妳的錢包會怎麼死嗎？快來測驗看看吧！',
    fb_share_wisdom,
    fb_share_href_princess: 'https://shopaholic.relab.cc/princess/3/',
    fb_share_href_quote: 'https://shopaholic.relab.cc/slogan/3/',
    fb_share_href_game: 'https://shopaholic.relab.cc/'
  },
  {
    title: '紅舞鞋之死',
    tag: 'commitment',
    quote: '優雅是去蕪存菁',
    quote_from: 'Cristóbal Balenciaga',
    wisdom: '購物時，妳就像停不下來的紅鞋女孩，即使違背了妳的信念，還是要懂得適可而止',
    caption: '拜託！讓我停下來',
    bannerImage: 'bannerImg4',
    figureImage: 'figureImg4',
    fb_share_game: '我的錢包變成停不下來的紅鞋女孩死掉了，要懂得停下來才是上上策！想知道妳的錢包會怎麼死嗎？快來測驗看看吧！',
    fb_share_wisdom,
    fb_share_href_princess: 'https://shopaholic.relab.cc/princess/4/',
    fb_share_href_quote: 'https://shopaholic.relab.cc/slogan/4/',
    fb_share_href_game: 'https://shopaholic.relab.cc/'
  },
  {
    title: '摔下樓梯之死',
    tag: 'rarity',
    quote: '「這是最後一件」是21世紀最大的謊言',
    quote_from: 'Anonymous',
    wisdom: '購物時，妳就像被時間追著跑的灰姑娘，看到限時限量就不顧一切，反正先買再說',
    caption: '其實，超過時間 也沒關係',
    bannerImage: 'bannerImg5',
    figureImage: 'figureImg5',
    fb_share_game: '我的錢包變成摔下樓梯的灰姑娘死掉了，其實限時一點也不重要！想知道妳的錢包會怎麼死嗎？快來測驗看看吧！',
    fb_share_wisdom,
    fb_share_href_princess: 'https://shopaholic.relab.cc/princess/5/',
    fb_share_href_quote: 'https://shopaholic.relab.cc/slogan/5/',
    fb_share_href_game: 'https://shopaholic.relab.cc/'
  },
  {
    title: '腦弱之死',
    tag: 'authority',
    quote: '我不認為自己是個偶像，也不在乎別人的看法，我只做自己',
    quote_from: 'Audrey Hepburn',
    wisdom: '購物時，妳就像盲目聽從專家的國王，不能一味地相信時尚教主，要適合自己才重要',
    caption: '別再相信他們的話了',
    bannerImage: 'bannerImg6',
    figureImage: 'figureImg6',
    fb_share_game: '我的錢包變成聽信裁縫師的國王死掉了，專家的話不一定可信！想知道妳的錢包會怎麼死嗎？快來測驗看看吧！',
    fb_share_wisdom,
    fb_share_href_princess: 'https://shopaholic.relab.cc/princess/6/',
    fb_share_href_quote: 'https://shopaholic.relab.cc/slogan/6/',
    fb_share_href_game: 'https://shopaholic.relab.cc/'
  }
];

module.exports = results;



// WEBPACK FOOTER //
// ./app/data/results.js